import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { Plus, PencilSimple, Trash, CalendarBlank } from "@phosphor-icons/react";

export default function AdminTours() {
  const [tours, setTours] = useState([]);
  const reload = () => api.get("/tours").then(r => setTours(r.data));
  useEffect(() => { reload(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this tour and all its scheduled instances?")) return;
    await api.delete(`/tours/${id}`);
    reload();
  };

  return (
    <div className="p-10 md:p-12" data-testid="admin-tours">
      <div className="flex items-center justify-between">
        <div>
          <p className="label-eyebrow text-ms-stone">Catalog</p>
          <h1 className="serif text-4xl text-ms-earth mt-2">Tours</h1>
        </div>
        <Link to="/admin/tours/new" className="inline-flex items-center gap-2 px-5 py-3 bg-ms-earth text-ms-cream rounded-md hover:bg-ms-earth/90 label-eyebrow text-xs" data-testid="new-tour-btn">
          <Plus size={16} /> New tour
        </Link>
      </div>

      <div className="mt-8 bg-white border border-ms-edge rounded-2xl overflow-hidden">
        {tours.length === 0 ? <p className="p-8 text-ms-stone">No tours yet. Create your first.</p> :
          <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[640px]">
            <thead className="bg-ms-cream border-b border-ms-edge">
              <tr><th className="text-left p-4 label-eyebrow text-ms-stone text-xs">Tour</th><th className="text-left p-4 label-eyebrow text-ms-stone text-xs">Slug</th><th className="text-left p-4 label-eyebrow text-ms-stone text-xs">Price</th><th className="text-left p-4 label-eyebrow text-ms-stone text-xs">Active</th><th className="text-right p-4"></th></tr>
            </thead>
            <tbody>
              {tours.map(t => (
                <tr key={t.id} className="border-b border-ms-edge last:border-0 hover:bg-ms-cream/40">
                  <td className="p-4 text-ms-earth">{t.title}</td>
                  <td className="p-4 text-ms-stone">{t.slug}</td>
                  <td className="p-4 text-ms-earth">${t.base_price}</td>
                  <td className="p-4">{t.is_active ? <span className="text-ms-success">Yes</span> : <span className="text-ms-stone">No</span>}</td>
                  <td className="p-4 text-right space-x-2">
                    <Link to={`/admin/calendar?tour_id=${t.id}`} className="inline-flex items-center gap-1 text-ms-stone hover:text-ms-earth text-xs" data-testid={`schedule-tour-${t.slug}`}><CalendarBlank size={14} /> Manage dates</Link>
                    <Link to={`/admin/tours/${t.id}`} className="inline-flex items-center gap-1 text-ms-stone hover:text-ms-earth text-xs" data-testid={`edit-tour-${t.slug}`}><PencilSimple size={14} /> Edit</Link>
                    <button onClick={() => remove(t.id)} className="inline-flex items-center gap-1 text-ms-danger hover:opacity-80 text-xs" data-testid={`delete-tour-${t.slug}`}><Trash size={14} /> Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        }
      </div>
    </div>
  );
}
